// extracted by mini-css-extract-plugin
module.exports = {"Up":"ArrowIcon-module--Up--3k7QH","Right":"ArrowIcon-module--Right--qw_Tq","Down":"ArrowIcon-module--Down--CpHlf","Left":"ArrowIcon-module--Left--2nToy"};